import scrollIntoView from 'smooth-scroll-into-view-if-needed';

export const isRequiredError = ({ error, type }) =>
  error && type === 'required';

export const validateMissingFields = errors =>
  Object.values(errors)
    .filter(error => Boolean(error))
    .some(error => isRequiredError(error));

export const validateErrors = errors =>
  Object.values(errors).some(({ error }) => error);

export const scrollToElement = elementId => {
  const node = document.getElementById(elementId);

  if (node) {
    scrollIntoView(node, {
      block: 'nearest',
      scrollMode: 'if-needed',
      behavior: 'smooth',
    });
  }
};

export const getFieldId = (name, formName) => {
  return formName ? `${formName}_${name}` : name;
};
